import { useSyncExternalStore } from "react";

export type Route =
  | { name: "feed" }
  | { name: "topic"; id: string }
  | { name: "connect" }
  | { name: "akvaryum" }
  | { name: "gizlilik" }
  | { name: "kosullar" }
  | { name: "notfound" };

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;

export function parseRoute(pathname: string): Route {
  const path = pathname.replace(/\/+$/, "") || "/";
  if (path === "/") return { name: "feed" };
  if (path === "/baglan") return { name: "connect" };
  if (path === "/akvaryum") return { name: "akvaryum" };
  if (path === "/gizlilik") return { name: "gizlilik" };
  if (path === "/kosullar") return { name: "kosullar" };
  const m = /^\/b\/([^/]+)$/.exec(path);
  if (m?.[1] && UUID.test(m[1])) return { name: "topic", id: m[1] };
  return { name: "notfound" };
}

const NAV_EVENT = "sikilesi:navigate";

function subscribe(cb: () => void): () => void {
  window.addEventListener("popstate", cb);
  window.addEventListener(NAV_EVENT, cb);
  return () => {
    window.removeEventListener("popstate", cb);
    window.removeEventListener(NAV_EVENT, cb);
  };
}

const snapshot = () => window.location.pathname;

export function usePathname(): string {
  return useSyncExternalStore(subscribe, snapshot, () => "/");
}

/** Keep ?tam while navigating inside the tam edition on hosts without the tam. subdomain. */
export function withEditionQuery(href: string): string {
  const keep = new URLSearchParams(window.location.search).has("tam");
  if (!keep || href.includes("?")) return href;
  const [path, hash] = href.split("#");
  return `${path ?? ""}?tam${hash !== undefined ? `#${hash}` : ""}`;
}

export function navigate(href: string): void {
  window.history.pushState(null, "", withEditionQuery(href));
  window.dispatchEvent(new Event(NAV_EVENT));
  if (!href.includes("#")) window.scrollTo({ top: 0 });
}
